'use client';

import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { Button, Container } from '@/components';

import styles from './ourClientsHero.module.scss';
import { HeroList, Subtitle, Title } from '../../components';
import { useVisible } from '@/hooks';
import { OurClientsCards } from './OurClientsCards/OurClientsCards';

interface OurClientsHeroProps {
  data: Simplify<Content.HeroSliceOurClientsPrimary>;
}
export const OurClientsHero = ({ data }: OurClientsHeroProps) => {
  const [isVisible, id] = useVisible();

  return (
    <Container styles={styles.container} id={id}>
      <article className={styles.text_content}>
        <Title text={data.title} isVisible={isVisible} />
        <Subtitle
          subtitle={data.subtitle}
          isVisible={isVisible}
          styles={styles.subtitle}
        />
        <HeroList list={data.advantages} isVisible={isVisible} />
        <div
          className={`${styles.button_wrapper} ${isVisible ? styles.isVisible : ''}`}
        >
          <Button
            variation="primary"
            text={data.button_text}
            link={data.button_link}
            isArrow
          />
        </div>
      </article>
      <OurClientsCards data={data} isVisible={isVisible} />
    </Container>
  );
};
